import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=daf75a3a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daf75a3a')) {
      api.createRecord('daf75a3a', component.options)
    } else {
      api.reload('daf75a3a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=daf75a3a&", function () {
      api.rerender('daf75a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20C1P7QHSytDB/JS/childrenage.vue"
export default component.exports